import React, { useEffect, useState } from "react";
import axios from 'axios';
import { useDispatch, useSelector } from "react-redux";
import MCSContainer from "./mcs.container";
import MCSSettingsContainer from "./mcs.settingscontainer";
import MCSImportExportContainer from "./mcs.importexportcontainer";
import MCSSHelpContainer from "./mcs.helpcontainer";
import { setActiveChannel } from "../Actions/Channel.action";
import { translate } from '../Services/translation';

export default function MCSMainContainer() {

    const dispatch = useDispatch();
    const activeChannelId = useSelector((state) => state.channel.activeChannelId);

    const [activeContainer, setActiveContainer] = useState(1);
    const [channels, setChannels] = useState(null);

    useEffect(() => {
        getAllChannels();
    }, []);

    const getAllChannels = () => {
        return axios.get(`/api/mcs/getallchannels`)
            .then(res => {
                if (res.data) {
                    setChannels(res.data);
                }
            })
    }

    const changeActiveContainer = (value) =>{
        setActiveContainer(value);
    }

    const changeActiveChannel = (e) => {
        return axios.post(`/api/mcs/setChannel`, {channelId: e.target.value})
            .then(res => {
                dispatch(setActiveChannel(e.target.value));
            })
    }

    return (
        <>
            <div className="mcs-main">
                <div className="mcs-main__button-container row">
                    <div className={activeContainer == 1 ? "mcs-main__button no-select mcs-main__button--active" : "mcs-main__button no-select green-background"} onClick={() => changeActiveContainer(1)}>{translate("mcs.rules")}</div>
                    <div className={activeContainer == 2 ? "mcs-main__button no-select mcs-main__button--active" : "mcs-main__button no-select green-background"} onClick={() => changeActiveContainer(2)}>{translate("mcs.importexport")}</div>
                    <div className={activeContainer == 3 ? "mcs-main__button no-select mcs-main__button--active" : "mcs-main__button no-select green-background"} onClick={() => changeActiveContainer(3)}>{translate("mcs.settings")}</div>
                    <div className={activeContainer == 4 ? "mcs-main__button no-select mcs-main__button--active" : "mcs-main__button no-select orange-background"} onClick={() => changeActiveContainer(4)}>{translate("mcs.help")}</div>
                    <select className="mcs-main__channel-select" onChange={changeActiveChannel}>{translate("mcs.channelselector")}
                        {channels && Object.entries(channels).map(([key, value]) => (
                            <option key={key} selected={key == activeChannelId} value={key}>{value}</option>
                        ))}
                    </select>
                </div>
            </div>
            {activeContainer == 1 &&
                <MCSContainer />
            }
            {activeContainer == 2 &&
                <MCSImportExportContainer />
            }
            {activeContainer == 3 &&
                <MCSSettingsContainer />
            }
            {activeContainer == 4 &&
                <MCSSHelpContainer />
            }
        </>
    );
}

